import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';

import { ForgerockAuthService } from '../../auth/forgerock-auth.service';
import { forgerockLogin } from './forgerock-session.actions';
import { loginUserFail, loginUserSuccess } from './session.actions';

export const login = createEffect(
  (actions$ = inject(Actions), forgerockAuthService = inject(ForgerockAuthService)) => {
    return actions$.pipe(
      ofType(forgerockLogin),
      switchMap(() =>
        forgerockAuthService.forgerockLogin().pipe(
          map(loginResponse => {
            if (!loginResponse) {
              return loginUserFail();
            }
            return loginUserSuccess(loginResponse);
          }),
          catchError(error => {
            return of(loginUserFail(error));
          })
        )
      )
    );
  },
  { functional: true }
);
